import { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import List from "@mui/material/List";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import Avatar from "@mui/material/Avatar";
import ButtonBase from "@mui/material/ButtonBase";
import Divider from "@mui/material/Divider";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import ListItemText from "@mui/material/ListItemText";
import ListItemAvatar from "@mui/material/ListItemAvatar";
import ListItemButton from "@mui/material/ListItemButton";
import ScheduleOutlinedIcon from "@mui/icons-material/ScheduleOutlined";
import NotificationsIcon from "@mui/icons-material/Notifications";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function renderContent(notification) {
  const title = (
    <>
      <Typography
        paddingLeft="0.7vw"
        variant="subtitle2"
        color="var(--white)"
        fontWeight={600}
      >
        {notification.sender_name}
      </Typography>
      <Typography variant="body2" color="var(--white)">
        &nbsp; {notification.subject}
      </Typography>
    </>
  );
  return {
    avatar: notification.avatar ? (
      <img alt={notification.title} src={notification.avatar} />
    ) : null,
    title,
  };
}

function NotificationItem({ notification, onClick }) {
  const { avatar, title } = renderContent(notification);
  const time = notification.time_since_creation;

  const handleClick = () => {
    // Call the onClick callback passed from the parent component
    onClick(notification);
  };

  return (
    <ButtonBase onClick={handleClick}>
      <ListItemButton
        sx={{
          py: 1.5,
          px: 2.5,
          mt: "1px",
          ...(notification.read && {
            bgcolor: "rgba(0, 0, 0, 0.5)",
          }),
        }}
      >
        {/* <ListItemAvatar>
          <Avatar sx={{ bgcolor: "background.neutral" }}>{avatar}</Avatar>
        </ListItemAvatar> */}
        <ListItemText
          primary={title}
          secondary={
            <>
              <Typography
                variant="caption"
                sx={{
                  mt: 0.5,
                  display: "flex",
                  alignItems: "center",
                  color: "var(--color-white-50)",
                }}
              >
                <ScheduleOutlinedIcon sx={{ mr: 0.5, width: 16, height: 16 }} />
                {time}
              </Typography>
            </>
          }
        />
      </ListItemButton>
    </ButtonBase>
  );
}

export default function NotificationsPopover() {
  const [notifications, setNotifications] = useState([]);
  const [open, setOpen] = useState(null);
  console.log("Notification", notifications);
  const navigate = useNavigate();

  useEffect(() => {
    GetFeedbacks();
    return () => {
      // Cleanup code, if needed
    };
  }, []);

  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };
  const handleClose = () => {
    setOpen(null);
  };
  const totalUnRead = notifications.filter(
    (item) => item.read === false
  ).length;

  const handleClick = async (notification) => {
    try {
      const updatedNotification = { ...notification, read: true };
      const response = await axios.post(
        "http://127.0.0.1:8000/admins/update-read",
        updatedNotification
      );
      if (response.status === 200) {
        console.log("Successful", response.data);
        GetFeedbacks();
        navigate("/admin/queries");
      } else {
        console.error("Error:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
    console.log("best");
  };

  const GetFeedbacks = async () => {
    try {
      const response = await axios.get(
        "http://127.0.0.1:8000/admins/get-all-unreaded-feedback"
      );

      if (response.status === 200) {
        setNotifications(response.data.feedbacks);
      } else {
        console.error("Error:", response.data);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };
  return (
    <>
      <IconButton
        color={open ? "primary" : "default"}
        onClick={handleOpen}
        sx={{
          color: "var(--color-white-50)",
          transition: "color 0.3s ease-out",
          "&:hover": {
            color: "var(--white)",
          },
        }}
      >
        <Badge badgeContent={totalUnRead} color="error">
          {open ? (
            <NotificationsIcon
              sx={{
                fontSize: 30,
                color: "var(--white)",
              }}
            />
          ) : (
            <NotificationsNoneOutlinedIcon
              sx={{
                fontSize: 30,
              }}
            />
          )}
        </Badge>
      </IconButton>
      <Popover
        open={!!open}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 0.5,
            ml: 0.75,
            width: 260,
            backgroundColor: "#222222", //#201939eb
          },
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", py: 2, px: 2.5 }}>
          <Box sx={{ flexGrow: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{ color: "white", fontWeight: 600 }}
            >
              Notifications
            </Typography>
            <Typography variant="body2" sx={{ color: "var(--color-white-50)" }}>
              You have {totalUnRead} unread messages
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ borderStyle: "dashed", background: "white" }} />
        <List disablePadding sx={{ backgroundColor: "var(--gray-100)" }}>
          {notifications
            .filter((notification) => !notification.read)
            .map((notification) => (
              <>
                <NotificationItem
                  key={notification.id}
                  notification={notification}
                  onClick={() => handleClick(notification)}
                />
                <Divider
                  sx={{
                    borderStyle: "dashed",
                    background: "var(--color-white-50)",
                  }}
                />
              </>
            ))}
        </List>
        <Divider sx={{ borderStyle: "dashed", background: "white" }} />
        <Box sx={{ p: 1 }}>
          <Button
            fullWidth
            disableRipple
            sx={{ color: "var(--red)", "&:hover": { background: "#291d1d" } }}
            onClick={() => navigate("/admin/queries")}
          >
            View All
          </Button>
        </Box>
      </Popover>
    </>
  );
}
